import adlanding from './ppclanding/routes';
export default [adlanding];
